import React, {useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import WizButton from '../../../components/button/WizButton'
import useNavigation from '../../../hooks/useNavigation'
import FloatingMessageTable from '../../../features/page/leaderboard/floatingMessage/FloatingMessageTable'

interface IProps {
    className?: string
}

const FloatingMessagePage: React.FC<IProps> = ({className}) => {
    const [showActive, setShowActive] = useState(true)
    const [priorityUpdate, setPriorityUpdate] = useState(false)
    const {goFloatingMessageCreate} = useNavigation()

    return (
        <PageLayout title={'Floating Message'}>
            <div className="flex justify-between items-center sm:block">
                <div className={'flex items-center space-x-[10px] sm:space-x-0 sm:flex sm:items-start sm:gap-x-[10px]'}>
                    <WizButton
                        type={'primary'}
                        text={'Create Floating Message'}
                        onClick={() => goFloatingMessageCreate()}
                    />
                    <WizButton
                        type={'blue'}
                        text={showActive ? 'Show All Item' : 'Show Progress Item'}
                        onClick={() => setShowActive(prev => !prev)}
                    />
                </div>
            </div>

            <div className={'mt-[30px]'}>
                <FloatingMessageTable active={showActive} />
            </div>
        </PageLayout>
    )
}

export default FloatingMessagePage
